

import SweetAlert from 'sweetalert2'
import styles from'./Alert.module.scss'

export default (
  props: {
    title?: string,
    text?: string,
    confirmButtonText?: string,
    cancelButtonText?: string,
  }
): Promise<boolean> => {
  // if (!props.title && props.text)
  // {
  //   props.title = props.text
  //   props.text = undefined;
  // }

  return new Promise(async (resolve) => {
    const result = await SweetAlert.fire({

      // icon: "warning",
      showCancelButton: true,
      animation: false,
      allowOutsideClick: false,
      confirmButtonText: "Verwijderen",
      cancelButtonText: "Annuleren",
      ...props,
      customClass: {
        actions: styles.actions,
        title: styles.title,
        htmlContainer: styles.htmlContainer,
        confirmButton: styles.btnSuccess,
        cancelButton: styles.btnCancel
      },
      buttonsStyling: false
    });
    resolve(result.isConfirmed)
  })

}

